<template>
  <div class="auth-wrapper auth-v2 mobile-only">
    <!-- Video Background -->
    <!-- <video autoplay muted loop id="bg-video">
      <source :src="backgroundVideo" type="video/mp4" />
      {{ $t('Seu navegador não suporta o elemento de vídeo.') }}
    </video> -->
    <!-- Background Image -->
    <div id="bg-image"></div>

    <div class="d-flex justify-content-center align-items-center vh-100">
      <b-row class="auth-inner m-0 w-100 justify-content-center">
        <!-- Registro -->
        <b-col sm="10" class="d-flex align-items-center auth-bg px-2 p-lg-2">
          <b-col sm="12" class="px-xl-2 mx-auto">
            <div class="text-center mb-2">
              <!-- Logo -->
              <b-link class="brand-logo">
                <b-img fluid :src="imgLogo2" alt="Logo Smartby" style="max-height: 10rem" />
              </b-link>
              <!-- /Logo -->
            </div>
            <b-card-title class="mb-1 text-white font-weight-bold" title-tag="h2">
              {{ $t("Junte-se à revolução dos pools de liquidez!") }} 🌐
            </b-card-title>
            <b-card-text class="mb-2">
              {{
                $t(
                  "Participe dos nossos pools e comece a gerar rendimentos com estratégias automatizadas."
                )
              }}
            </b-card-text>

            <!-- Formulário de Registro -->
            <validation-observer ref="registerForm" #default="{ invalid }">
              <div class="my-1">
                <strong>Indicado por: {{ upline }}</strong>
              </div>
              <b-form class="auth-register-form mt-2" @submit.prevent="register">
                <!-- Nome e Sobrenome -->
                <label for="register-fullname">{{
                  $t("Nome e Sobrenome")
                  }}</label>
                <b-form-group>
                  <validation-provider #default="{ errors }" mode="eager" name="Fullname" vid="fullname"
                    rules="required|min:6|max:100">
                    <b-form-input id="register-fullname" v-model="fullname" name="register-fullname"
                      :state="errors.length > 0 ? false : null" placeholder="Seu nome completo" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- E-mail -->
                <label for="register-email">{{ $t("E-mail") }}</label>
                <b-form-group>
                  <validation-provider #default="{ errors }" mode="eager" name="Email" vid="email"
                    rules="required|min:6|max:80|email">
                    <b-form-input id="register-email" v-model="userEmail" name="register-email"
                      :state="errors.length > 0 ? false : null" placeholder="exemplo@smartby.com" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Senha -->
                <label for="register-password">{{ $t("Crie uma senha") }}</label>
                <b-form-group>
                  <validation-provider #default="{ errors }" mode="eager" name="Password" vid="password"
                    rules="required|min:4">
                    <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                      <b-form-input id="register-password" v-model="password" class="form-control-merge"
                        :type="passwordFieldType" :state="errors.length > 0 ? false : null" name="register-password"
                        placeholder="Escolha uma senha segura" />
                      <b-input-group-append is-text>
                        <feather-icon :icon="passwordToggleIcon" class="cursor-pointer"
                          @click="togglePasswordVisibility" />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- País -->
                <label for="register-country">{{ $t("País de Residência") }}</label>
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    mode="eager"
                    name="Country"
                    vid="country"
                    rules="required"
                  >
                    <v-select
                      id="register-country"
                      v-model="country"
                      :options="countryOptions"
                      placeholder="Selecione seu país"
                      :reduce="(country) => country.value"
                      :class="{ 'is-invalid': errors.length > 0 }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Telefone -->
                <label for="register-phone">{{ $t("Telefone") }}</label>
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    mode="eager"
                    name="Phone"
                    vid="phone"
                  >
                    <b-form-input
                      id="register-phone"
                      v-model="phone"
                      name="register-phone"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Digite seu telefone com DDD"
                      inputmode="numeric"
                      @keypress="onlyNumber($event)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Termos de Uso -->
                <b-form-group>
                  <b-form-checkbox id="register-privacy-policy" v-model="terms" name="RgisterPrivacyPolicy"
                    type="checkbox" :state="terms == false ? false : null">
                    {{ $t("Eu aceito os") }}
                    <b-link>{{ $t("termos de uso") }}</b-link>
                  </b-form-checkbox>
                  <small class="text-danger" v-if="terms == false">{{
                    $t("Você deve aceitar os termos de uso para continuar.")
                    }}</small>
                </b-form-group>

                <!-- Botão de Enviar -->
                <b-button variant="primary" block type="submit" :disabled="loading || terms == false">
                  <div v-if="!loading">
                    {{ $t("Registrar-se") }}
                  </div>
                  <div v-else>
                    <b-spinner small type="grow"></b-spinner>
                    {{ $t("Carregando...") }}
                  </div>
                </b-button>
              </b-form>
            </validation-observer>

            <!-- Link para Login -->
            <p class="text-center mt-2">
              <span>{{ $t("Já possui uma conta?") }}</span>
              <b-link :to="{ name: 'login' }">
                <span>&nbsp;{{ $t("Faça login") }}</span>
              </b-link>
            </p>

            <div class="text-center btnLocaleTheme mt-2">
              <Locale :urlParams="this.$route.params.locale" />
            </div>
          </b-col>
        </b-col>
        <!-- /Registro -->
      </b-row>
    </div>
  </div>
</template>


<script>
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { required, email, min, max } from "@/libs/validations";
import ProjectLogo from "@/layouts/logo/LogoProjectX.vue";
import GoogleLogo from "@/layouts/logo/LogoGoogle.vue";
import ProjectXLogo from "@/layouts/logo/LogoProjectX.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
  BSpinner,
} from "bootstrap-vue";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import { mapGetters, mapActions } from "vuex";
import DeviceDetector from "device-detector-js";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import Locale from "@/layouts/components/Locale.vue";

import { heightFade } from "@core/directives/animations";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    ProjectLogo,
    GoogleLogo,
    ProjectXLogo,
    ValidationProvider,
    ValidationObserver,
    Locale,
    BSpinner,
    vSelect
  },
  directives: {
    "b-tooltip": VBTooltip,
    "height-fade": heightFade,
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      sideImg: require("@/assets/images/pages/login-v2.svg"),

      // validation rules
      required,
      email,
      min,
      max,

      //Alert
      apiErrorMessage: "",
      alertLogin: false,

      // Background video
      backgroundVideo: require("@/assets/videos/background.mp4"),

      fullname: "",
      userEmail: "",
      password: "",
      phone: "",
      country: null,
      terms: null,
      countryOptions: [
        { value: "ZA", label: "África do Sul" },
        { value: "DE", label: "Alemanha" },
        { value: "SA", label: "Arábia Saudita" },
        { value: "AR", label: "Argentina" },
        { value: "AU", label: "Austrália" },
        { value: "AT", label: "Áustria" },
        { value: "BD", label: "Bangladesh" },
        { value: "BE", label: "Bélgica" },
        { value: "BR", label: "Brasil" },
        { value: "CA", label: "Canadá" },
        { value: "CL", label: "Chile" },
        { value: "CN", label: "China" },
        { value: "CO", label: "Colômbia" },
        { value: "KR", label: "Coreia do Sul" },
        { value: "DK", label: "Dinamarca" },
        { value: "EG", label: "Egito" },
        { value: "AE", label: "Emirados Árabes Unidos" },
        { value: "ES", label: "Espanha" },
        { value: "US", label: "Estados Unidos" },
        { value: "PH", label: "Filipinas" },
        { value: "FI", label: "Finlândia" },
        { value: "FR", label: "França" },
        { value: "GR", label: "Grécia" },
        { value: "HK", label: "Hong Kong" },
        { value: "HU", label: "Hungria" },
        { value: "IN", label: "Índia" },
        { value: "ID", label: "Indonésia" },
        { value: "IR", label: "Irã" },
        { value: "IE", label: "Irlanda" },
        { value: "IL", label: "Israel" },
        { value: "IT", label: "Itália" },
        { value: "JP", label: "Japão" },
        { value: "MY", label: "Malásia" },
        { value: "MX", label: "México" },
        { value: "NG", label: "Nigéria" },
        { value: "NO", label: "Noruega" },
        { value: "NL", label: "Países Baixos" },
        { value: "PK", label: "Paquistão" },
        { value: "PL", label: "Polônia" },
        { value: "PT", label: "Portugal" },
        { value: "GB", label: "Reino Unido" },
        { value: "RU", label: "Rússia" },
        { value: "SE", label: "Suécia" },
        { value: "CH", label: "Suíça" },
        { value: "SG", label: "Singapura" },
        { value: "TH", label: "Tailândia" },
        { value: "TR", label: "Turquia" },
        { value: "UA", label: "Ucrânia" },
        { value: "VN", label: "Vietnã" }
      ],
      sideImg: require("@/assets/images/pages/register-v2.svg"),
      loading: false,
      emailError: "",

      upline: null,
    };
  },
  computed: {
    ...mapGetters(["returnLocale"]),
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      return require("@/assets/images/business_plan/img_login3.png");
    },
    imgLogo() {
      if (store.state.appConfig.layout.skin === "dark") {
        return require("@/assets/images/logo/smartby_logo_light.png");
      } else {
        return require("@/assets/images/logo/smartby_logo_dark.png");
      }
    },
    imgLogo2() {
      return require("@/assets/images/logo/smartby_logo_light.png");
    },
  },
  watch: {
    returnLocale: function (oldVal, newVal) {
      localize(oldVal);
    },
  },
  mounted() {
    document.getElementById("loading-bg").style.display = "block";
    this.$store
      .dispatch("verifyUpline", this.$route.params.upline)
      .then((resp) => {
        this.upline = resp;
        document.getElementById("loading-bg").style.display = "none";
      })
      .catch(() => {
        this.$router.push("/login");
        document.getElementById("loading-bg").style.display = "none";
      });
  },
  methods: {
    ...mapActions(["userRegister", "recoverUserData"]),
    onlyNumber(event) {
      // Permitir apenas teclas numéricas, backspace, delete, setas e tab
      const key = event.key;
      if (!/^[0-9]$/.test(key) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(key)) {
        event.preventDefault();
      }
    },
    register() {
      this.$refs.registerForm.validate().then((success) => {
        if (success) {
          this.loading = true;
          if (!this.terms) {
            this.terms = false;
            this.loading = false;
          } else {
            // const deviceDetector = new DeviceDetector();
            // const userAgent = navigator.userAgent;
            // const device = deviceDetector.parse(userAgent);

            const data = {
              fullname: this.fullname,
              email: this.userEmail.toLowerCase(),
              password: this.password,
              upline: this.$route.params.upline,
              phone: this.phone,
              country: this.country,
              // device_name:
              //   "OS: " +
              //   device.os.name +
              //   " | Device: " +
              //   device.device.type +
              //   " | Client: " +
              //   device.client.type +
              //   " . " +
              //   device.client.name +
              //   " . " +
              //   device.client.version,
              // terms: this.terms,
            };

            this.userRegister(data)
              .then(() => {
                this.recoverUserData()
                  .then((response) => {
                    this.$toast({
                      component: ToastificationContent,
                      position: "top-right",
                      props: {
                        icon: "CoffeeIcon",
                        variant: "success",
                        title:
                          this.$i18n.t("Bem-vindo ") +
                          response.data.user.fullname,
                        text: this.$i18n.t(
                          "Seu cadastro foi realizado com sucesso!"
                        ),
                      },
                    });
                    this.$ability.update(response.data.user.roles);
                    this.loading = false;
                    this.$router.push("/");
                  })
                  .catch((error) => {
                    if (error.status == 500) {
                      this.$toast({
                        component: ToastificationContent,
                        position: "top-right",
                        props: {
                          icon: "CoffeeIcon",
                          variant: "danger",
                          title: error.data.message,
                        },
                      });
                    } else {
                      this.$refs.registerForm.setErrors(error.data.errors);
                    }
                    this.loading = false;
                  });
              })
              .catch((error) => {
                if (error.status == 500) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      icon: "CoffeeIcon",
                      variant: "danger",
                      title: error.data.message,
                    },
                  });
                } else {
                  this.$refs.registerForm.setErrors(error.data.errors);
                }
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.auth-wrapper {
  position: relative;
  height: 100vh;
  overflow: hidden;
}

#bg-video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -100;
  transform: translateX(-50%) translateY(-50%);
  background: no-repeat;
  background-size: cover;
}

#bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('../../../public/background.png');
  background-size: cover;
  background-position: center;
  z-index: -100;
}

.auth-inner {
  width: 100%;
  max-width: 550px;
  background: rgba(0, 22, 27, 0.9);
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.5);
  color: #fff;
}

.auth-inner * {
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.0);
}

label {
  color: #fff;
}

.small {
  color: #fff;
}

.b-form-input,
.b-form-group,
.b-input-group,
.b-button {
  background: rgb(0, 25, 39);
  color: #fff;
  border: 1px solid #fff;
}

.b-link {
  color: #fff;
}

.b-alert {
  background: rgba(255, 0, 0, 0.5);
  color: #fff;
}

.b-card-title,
.b-card-text {
  color: #fff;
}

.b-card-title {
  font-size: 2rem;
  font-weight: bold;
}

.b-card-text {
  font-size: 1.2rem;
}

/* Estilo para o select de país (v-select) */
.v-select {
  background-color: #ffffff; /* Fundo branco */
  color: #000000; /* Texto preto */
  border: 1px solid #ccc; /* Bordas cinza claras */
}

.v-select .vs__dropdown-toggle {
  background-color: #ffffff; /* Fundo branco no toggle */
  color: #000000; /* Texto preto no toggle */
}

.v-select .vs__selected-options {
  background-color: #ffffff; /* Fundo branco para opções selecionadas */
  color: #000000; /* Texto preto para opções selecionadas */
}

.v-select .vs__dropdown-menu {
  background-color: #ffffff; /* Fundo branco no menu dropdown */
  color: #000000; /* Texto preto no menu dropdown */
}

.v-select .vs__dropdown-menu .vs__dropdown-option {
  color: #000000; /* Texto preto nas opções */
}

/* Ajustes adicionais para o modo escuro */
.v-select .vs__dropdown-menu .vs__dropdown-option--selected {
  background-color: #e0e0e0; /* Fundo cinza claro para a opção selecionada */
}
</style>

